module.exports = __webpack_public_path__ + "static/media/logo-full-color-medium-inverted.b56c6a54.png";